export enum DateFilterType {
  LAST_7_DAYS = "last_7_days",
  LAST_15_DAYS = "last_15_days",
  LAST_30_DAYS = "last_30_days",
}
